export const clusterLayer = {
  id: 'clusters',
  type: 'symbol',
  source: 'stop_cluster',
  filter: ['has', 'point_count'],
  layout: {
    'icon-image': 'stop-cluster',
    'icon-size': ['step', ['get', 'point_count'], 0.625, 10, 0.75, 100, 0.875, 1000, 1],
    'icon-allow-overlap': true,
    'text-field': '{point_count}',
    'text-font': ['Arial Unicode MS Bold'],
    'text-size': 14,
  },
  paint: {
    'text-color': '#ffffff',
  },
};
export const unclusteredPointLayer = {
  id: 'unclustered-point',
  type: 'symbol',
  source: 'stop_cluster',
  filter: ['!', ['has', 'point_count']],
  layout: {
    'icon-anchor': 'bottom',
    'icon-image': 'stop-{icon}',
    'icon-size': 0.45,
    'icon-allow-overlap': true,
  },
};
